import { getUserInfo, getUserProfile } from 'app/selectors';

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const userRoles: Record<string, string> = {
    NTCAdministrator: 'Администратор НТЦ',
    IBAdministrator: 'Администратор ИБ',
    OCExpert: 'Эксперт ОЦ',
    OCUser: 'ОЦ',
    UKSUser: 'УКС',
    OKUser: 'ОК',
    SMRContractor: 'Подрядчик СМР',
};

/**
 * `useProfileInfo`: вернет объект с информацией о текущем пользователе
 * @returns {userName, organisation, role}
 */
export const useProfileInfo = (): {
    userName?: string;
    organisation?: string;
    role?: string;
} => {
    const profileInfo = useSelector(getUserProfile) as { roles: string[]; username: string } | undefined;
    const userInfo = useSelector(getUserInfo) as { company: string } | undefined;

    const translatedRoles = useMemo(
        () =>
            profileInfo?.roles?.reduce((acc: string[], item) => {
                if (userRoles[item]) {
                    acc.push(userRoles[item]);
                }

                return acc;
            }, []),
        [profileInfo?.roles],
    );

    return useMemo(
        () => ({
            ...(profileInfo?.username ? { userName: profileInfo?.username } : undefined),
            ...(userInfo?.company ? { organisation: userInfo?.company } : undefined),
            ...(translatedRoles?.length ? { role: translatedRoles.join(', ') } : undefined),
        }),
        [profileInfo?.username, translatedRoles, userInfo?.company],
    );
};
